import PriorityQueue from "priorityqueuejs";

class QueueEntry {
    baseTime;
    timeline;
    action;
    deleted;

    constructor(props) {
        this.baseTime = props.baseTime;
        this.timeline = props.timeline;
        this.action = props.action;
        this.deleted = false;
    }

    get schedule() {
        return this.baseTime + this.action.startTime;
    }

    static compare(a, b) {
        return b.schedule - a.schedule;
    }

    hasClass(className) {
        return this.timeline.className === className;
    }
}

export default class ActionQueue {
    queue;

    constructor() {
        this.queue = new PriorityQueue((a, b) => QueueEntry.compare(a, b));
    }

    add(timeline, baseTime, actions) {
        for (let action of actions) {
            this.queue.enq(new QueueEntry({
                baseTime,
                timeline,
                action
            }));
        }
    }

    pruneDeleted() {
        while (isHeadDeleted(this.queue)) {
            this.queue.deq();
        }

        function isHeadDeleted(q) {
            return !q.isEmpty() && q.peek().deleted;
        }
    }

    isEmpty() {
        this.pruneDeleted();
        return this.queue.isEmpty();
    }

    *nextAction(maxTime) {
        this.pruneDeleted();
        for (const eq = this.queue; !eq.isEmpty() && eq.peek().schedule <= maxTime;)
            yield eq.deq().action;
    }

    prune(className) {
        this.queue.forEach(entry => {
            if (entry.hasClass(className))
                entry.deleted = true;
        });
    }

    getCurrentTimeline() {
        this.pruneDeleted();
        if (!this.queue.isEmpty()) {
            return this.queue.peek().timeline;
        }
        return null;
    }
}
